/**
 * ListDetailLayout Component
 *
 * A reusable layout pattern for displaying a list and details side-by-side.
 * Ideal for workflows where users need to browse through a queue of items while viewing
 * and editing details without leaving the page.
 */

export { ListDetailLayout } from './ListDetailLayout';
export { ListPanel } from './ListPanel';
export { DetailPanel } from './DetailPanel';
export { ListDetailStyles } from './ListDetailStyles';
export { ListDetailToolbar } from './ListDetailToolbar';
export * from './types';

// Backward compatibility exports (deprecated - use ListDetail* instead)
export { ListDetailLayout as MasterDetailLayout } from './ListDetailLayout';
export { ListPanel as MasterPanel } from './ListPanel';
export { ListDetailStyles as MasterDetailStyles } from './ListDetailStyles';
export { ListDetailToolbar as MasterDetailToolbar } from './ListDetailToolbar';
